/* eslint-disable no-bitwise -- intentional bitwise operations for UUID generation */
import { Injectable } from '@angular/core';

@Injectable()
export class UuidGenerationService {
  public generateUuid(): string {
    return crypto.randomUUID ? crypto.randomUUID() : this.fallbackGenerateUuid();
  }

  /**
   * crypto.randomUUID has 95% support
   */
  private fallbackGenerateUuid(): string {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
    );
  }
}
